import React, { useState } from "react";

import LandingPage from "../CommonComponent/LandingPage";
import OnboardingForm from "../CommonComponent/OnboardingForm/OnboardingForm";
import SuccessLandingPage from "../CommonComponent/SuccessLandingPage";

import onboardingBg from "../../../../assets/images/onboarding-bg.png";

export default function ProductLandingPage() {
  const [displayForm, setDisplayForm] = useState(false);
  const [success, setSuccess] = useState("");

  if (displayForm) {
    return <OnboardingForm formStep={1} setDisplayForm={setDisplayForm} setSuccess={setSuccess} />;
  }

  if ((success === "Product") && !displayForm) {
    return (
      <SuccessLandingPage success={success} image={onboardingBg} />
    );
  }

  return (
    <LandingPage
      heading={(
        <>
          Product Testing
          <br />
          journey with us
        </>
        )}
      description={(
        <>
          Please setup your product sample submission
          <br />
          fields to enable submitting product samples.
        </>
        )}
      image={onboardingBg}
      setDisplayForm={setDisplayForm}
    />
  );
}
